var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('h2',[_vm._v("\r\n        Events Dashboard\r\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger signout-btn",on:{"click":_vm.signOut}},[_vm._v("\r\n        Sign Out\r\n    ")]),_vm._v(" "),_c('AddEvent'),_vm._v(" "),_c('div',{staticClass:"col-md-12 row"},_vm._l((this.$store.state.events),function(event_item,index){return _c('EventItem',{key:"index",attrs:{"event":event_item}})}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c907a196","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 184
// module chunks = 0